import { Avatar, Button, Grid, IconButton, Typography } from "@mui/material";
import React, { SyntheticEvent, useEffect, useState } from "react";
import theme from "../../theme";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import HandshakeIcon from "@mui/icons-material/Handshake";
import CampaignIcon from "@mui/icons-material/Campaign";
import { Link } from "react-router-dom";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import DatePickerCalender, {
  DatePickerCalenderProps,
  DatePickerCalenderTypes,
} from "./DatePickerCalender";
import dayjs, { Dayjs } from "dayjs";
import weekdays from "dayjs/plugin/weekday";
import advFormat from "dayjs/plugin/advancedFormat";
import { useAppSelector } from "../../redux/hooks";
import formatDate from "../../util/dateFormat";
import { constant } from "../../constants";
import Loader from "../ui/Loader";
import VoucherDetails from "./Dashboard/VoucherDetails";
import PromotionDetails from "./Dashboard/PromotionDetails";
import DefaultImage from "../../assets/SuntecNewLogo.png";
import {
  filterConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

dayjs.extend(weekdays);
dayjs.extend(advFormat);

const tempData = {
  status: true,
  data: {
    image: {
      src: "",
    },
    eVoucherUtilized: {
      quantity: 33,
      totalAmount: 250,
      reimbursementCost: 150,
    },
    reimbursementStatus: {
      physicalVoucherReimbursement: {
        pending: 60,
        accepted: 45,
        rejected: 34,
      },
      eVoucherReimbursement: {
        pending: 54,
        accepted: 5,
        rejected: 43,
        lastReportGeneratedOn: "15 November 23, 04:00PM",
      },
    },
    flashSales: {
      activeFlashSales: 24,
    },
    rewards: {
      activeRewards: 4,
    },
    promotions: {
      activePromotions: 24,
    },
    merchantInfo: {
      name: "Super Sub",
      id: "48850990",
    },
  },
};
const DashboardNewUI = () => {
  const [data, setData] = useState(tempData.data);
  const [countsData, setCountsFPR] = useState<any>({});
  const [physicalVoucherCounts, setPhysicalVoucherCount] = useState<any>({});
  const [physicalEVoucherCounts, setPhysicalEVoucherCount] = useState<any>({});
  const [physicalTVoucherCounts, setPhysicalTVoucherCount] = useState<any>({});
  const [utilizedReports, setUtilizedReports] = useState<any>({});
  const [lastGenerated, setLastGenerated] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [merchant_logo, setMechantLogo] = useState("");
  const [merchant_Id, setMechant_Id] = useState("");
  const [loading, setLoading] = useState(false);
  const { getUserPermission: voucherTransactionPermissions } =
    usePermissionGetter(
      permissionsConstants.voucher_transaction,
      permissionsConstants.voucher_transaction
    );
  const { getUserPermission: dashboardPermissions } = usePermissionGetter(
    permissionsConstants.dashboard,
    permissionsConstants.dashboard
  );
  const { getUserPermission: physicalVoucherPermissions } = usePermissionGetter(
    permissionsConstants.physical_voucher_reimbursement,
    permissionsConstants.physical_voucher_reimbursement
  );
  const { getUserPermission: eVoucherPermissions } = usePermissionGetter(
    permissionsConstants.evoucher_reimbursement,
    permissionsConstants.evoucher_reimbursement
  );
  const { getUserPermission: activeFlashSalesPermissions } =
    usePermissionGetter(
      permissionsConstants.flash_sale,
      permissionsConstants.active_flash_sales
    );
  const { getUserPermission: activeRewardsPermissions } = usePermissionGetter(
    permissionsConstants.rewards,
    permissionsConstants.active_rewards
  );
  const { getUserPermission: activePromotionsPermissions } =
    usePermissionGetter(
      permissionsConstants.promotions,
      permissionsConstants.active_promotions
    );
  const handleError = (event: SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = DefaultImage;
  };
  useEffect(() => {
    if (constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN) {
      const { merchant_logo, merchantId } = selectedMerchatDetails;
      setMechantLogo(merchant_logo);
      setMechant_Id(merchantId);
    }
  }, []);
  const merchantExternalId = localStorage.getItem("externalId");
  const [calendarProps, setCalendarProps] = useState<DatePickerCalenderTypes>({
    anchor: null,
    calendarType: "Day",
    startDate: dayjs(),
    endDate: dayjs(),
  });

  const getDates = ({
    endDate,
    startDate,
    calendarType,
  }: DatePickerCalenderTypes) => {
    setUtilizedReports(null);
    if (calendarType === "Month") {
      const monthStart = startDate?.startOf("month").format("YYYY-MM-DD");
      const monthEnd = endDate?.endOf("month").format("YYYY-MM-DD");
      FetchVoucherTransaction(monthStart, monthEnd);
    } else if (calendarType === "Day") {
      const dayStart = startDate?.startOf("day").format("YYYY-MM-DD HH:mm:ss");
      const dayEnd = endDate
        ?.endOf("day")
        .hour(23)
        .minute(59)
        .second(59)
        .format("YYYY-MM-DD HH:mm:ss");
      FetchVoucherTransaction(dayStart, dayEnd);
    } else {
      FetchVoucherTransaction(
        startDate?.format("YYYY-MM-DD"),
        endDate?.format("YYYY-MM-DD")
      );
    }
  };

  const getDisplayDate = () => {
    switch (calendarProps.calendarType) {
      case "Month":
        return calendarProps.startDate?.format("MMMM YY");
      case "Week":
        return `${calendarProps.startDate?.format(
          "Do"
        )} - ${calendarProps.endDate?.format("Do MMMM YY")}`;
      case "Range":
        return `${calendarProps.startDate?.format(
          "Do MMM"
        )} - ${calendarProps.endDate?.format("Do MMM YY")}`;
      default:
        return calendarProps.startDate?.format("DD MMMM YY");
    }
  };
  //get counts of Vouchers
  function countReportStatus(data: any) {
    const statusCounts = {
      reject: 0,
      pending: 0,
      accept: 0,
    };

    data?.forEach((entry: any) => {
      const status = entry.report_status.toLowerCase();

      if (
        status === filterConstants.Reject.toLowerCase() ||
        status === filterConstants.Rejected.toLowerCase()
      ) {
        statusCounts.reject++;
      } else if (status === filterConstants.Pending.toLowerCase()) {
        statusCounts.pending++;
      } else if (
        status === filterConstants.Accept.toLowerCase() ||
        status === filterConstants.Accepted.toLowerCase() ||
        status === filterConstants.Submitted.toLowerCase()
      ) {
        statusCounts.accept++;
      }
    });

    return statusCounts;
  }
  function calculateAmountSum(data: any) {
    let sum = 0;
    data.forEach((entry: any) => {
      sum += entry.amount || 0;
    });
    return sum;
  }
  function calculateCost(data: any) {
    let sum = 0;
    data.forEach((entry: any) => {
      sum += entry.reimbursementCost || 0;
    });
    return sum;
  }

  const fetchDashboard = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + APIConstants.getDashboardDetails
      );
      const dashboardData = response.data.data;
      setData(dashboardData);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  // Voucher Transaction data
  const FetchVoucherTransaction = async (fromDate: any, toDate: any) => {
    try {
      setLoading(true);
      let url = `${
        process.env.REACT_APP_API_URL +
        APIConstants.getVoucherTransactionForMerchant
      }?merchantId=${merchantId}&fromDate=${fromDate}&toDate=${toDate}`;
      const response = await axios.get(url);

      const newData = response.data.result.data.value;
      const utilzedValue = {
        amount: calculateAmountSum(newData),
        quantity: response.data.result.data.count,
        reimbursementCost: calculateCost(newData),
      };
      setUtilizedReports(utilzedValue);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const FetchPhysicalVoucher = async (lastKey?: any) => {
    try {
      setLoading(true);
      let url = `${
        process.env.REACT_APP_API_URL +
        APIConstants.getReimbursementPVoucherCount
      }?voucher_type=physical&merchantId=${merchantId}&module=physical_voucher_reimbursement&feature=physical_voucher_reimbursement`;
      const voucherResponse = await axios.get(url);
      const data = voucherResponse.data.data.data[0] || {
        accept: 0,
        reject: 0,
        pending: 0,
      };
      const { accept, reject, pending } = data;
      const reportStatusCounts = {
        accept,
        reject,
        pending,
      };
      setPhysicalVoucherCount(reportStatusCounts);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const FetchEVoucher = async (lastKey?: any) => {
    try {
      setLoading(true);
      let url = `${
        process.env.REACT_APP_API_URL +
        APIConstants.getReimbursementEvoucherCount
      }?voucher_type=Evouchers&merchantId=${merchantId}&module=evoucher_reimbursement&feature=evoucher_reimbursement`;
      const voucherResponse = await axios.get(url);
      const data = voucherResponse.data.data.data[0] || {
        accept: 0,
        reject: 0,
        pending: 0,
      };
      const lastGeneratedDate = formatDate(data?.submitted_date);
      setLastGenerated(lastGeneratedDate);
      const { accept, reject, pending } = data;
      const reportStatusCounts = {
        accept,
        reject,
        pending,
      };
      setPhysicalEVoucherCount(reportStatusCounts);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const getCountsForFlashPromotionsRewards = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          APIConstants.getMerchantDeals +
          `?MerchantID=${merchantId}&merchantName=${external_id}&Status=Active`
      );
      const count = response.data.RecordCount;
      setCountsFPR(count);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCalendarProps((prev) => {
      getDates({
        ...prev,
        startDate: dayjs(),
        endDate: dayjs(),
      });
      return {
        ...prev,
        startDate: dayjs(),
        endDate: dayjs(),
      };
    });
  }, [calendarProps.calendarType]);

  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { external_id, merchantName, merchantId } = selectedMerchatDetails;

  const onLoadApis = () => {
    setPhysicalVoucherCount(null);
    setPhysicalEVoucherCount(null);
    setCountsFPR(null);
    getCountsForFlashPromotionsRewards();
    if (eVoucherPermissions("read")) FetchEVoucher();
    else {
      const reportStatusCounts = countReportStatus(null);
      setPhysicalEVoucherCount(reportStatusCounts);
    }
    if (physicalVoucherPermissions("read")) FetchPhysicalVoucher();
    else {
      const reportStatusCounts = countReportStatus(null);
      setPhysicalVoucherCount(reportStatusCounts);
    }
  };
  useEffect(() => {
    onLoadApis();
  }, [eVoucherPermissions("read"), physicalVoucherPermissions("read")]);
  return (
    <Grid
      height={"100vh"}
      width={"100%"}
      display={"flex"}
      flexDirection={"column"}
      gap={2}
    >
      {dashboardPermissions("read") && (
        <Grid height={"5%"} display={"flex"} alignItems={"end"}>
          <Typography
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: theme.font?.fontSize.large,
              fontWeight: theme.font?.fontWeight.thick,
            }}
          >
            Dashboard
          </Typography>
        </Grid>
      )}
      <Grid height={"35%"} display={"flex"} gap={3}>
        {dashboardPermissions("read") && (
          <Grid
            width={"30%"}
            borderRadius={"16px"}
            overflow={"hidden"}
            sx={{ background: theme.color?.sideMenuNewActive }}
            p={3}
            display={"flex"}
            flexDirection={"column"}
            gap={2}
          >
            <Grid
              height={"65%"}
              sx={{ background: theme.color?.background }}
              borderRadius={"16px"}
              overflow={"hidden"}
            >
              <img
                src={merchant_logo ? merchant_logo : DefaultImage}
                onError={handleError}
                alt="merchant-image"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "scale-down",
                }}
              ></img>
            </Grid>
            <Grid
              height={"35%"}
              display={"flex"}
              flexDirection={"column"}
              gap={1}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: "20px",
                  fontWeight: theme.font?.fontWeight.thicker,
                  color: theme.color?.background,
                }}
              >
                {merchantName}
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: "20px",
                  fontWeight: theme.font?.fontWeight.thicker,
                  color: theme.color?.background,
                }}
              >
                {external_id}
              </Typography>
            </Grid>
          </Grid>
        )}

        {dashboardPermissions("read") && (
          <Grid
            width={"70%"}
            borderRadius={"16px"}
            sx={{ background: theme.color?.background }}
            border={theme.border?.newGreyBorder}
            overflow={"hidden"}
          >
            <Grid
              height={"45%"}
              borderBottom={theme.border?.newGreyBorder}
              display={"flex"}
            >
              <Grid
                width={"60%"}
                display={"flex"}
                alignItems={"center"}
                gap={2}
                pl={"8vh"}
              >
                <Grid
                  borderRadius={"50%"}
                  p={1}
                  sx={{ backgroundColor: "#FFEAF3" }}
                  display={"flex"}
                  alignItems={"center"}
                >
                  <ReceiptIcon sx={{ color: "#E9A2BF" }} />
                </Grid>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: "20px",
                    fontWeight: theme.font?.fontWeight.thick,
                    color: "#949494",
                  }}
                >
                  e-Voucher Utilized
                </Typography>
              </Grid>
              <Grid width={"40%"}>
                <Grid
                  height={"50%"}
                  display={"flex"}
                  alignItems={"end"}
                  gap={1}
                  justifyContent={"center"}
                >
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "16px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color:
                        calendarProps.calendarType === "Day"
                          ? "#F1B53D"
                          : "#949494",
                      borderRight: theme.border?.newGreyBorder,
                      textTransform: "capitalize",
                    }}
                    px={1}
                    component={Button}
                    onClick={(e) =>
                      setCalendarProps((prev) => ({
                        ...prev,
                        anchor: e.currentTarget,
                        calendarType: "Day",
                      }))
                    }
                  >
                    Day
                  </Typography>
                  <Typography
                    component={Button}
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "16px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color:
                        calendarProps.calendarType === "Week"
                          ? "#F1B53D"
                          : "#949494",
                      borderRight: theme.border?.newGreyBorder,
                      textTransform: "capitalize",
                    }}
                    px={1}
                    onClick={(e) =>
                      setCalendarProps((prev) => ({
                        ...prev,
                        anchor: e.currentTarget,
                        calendarType: "Week",
                      }))
                    }
                  >
                    Week
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "16px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color:
                        calendarProps.calendarType === "Month"
                          ? "#F1B53D"
                          : "#949494",
                      textTransform: "capitalize",
                      borderRight: theme.border?.newGreyBorder,
                    }}
                    px={1}
                    component={Button}
                    onClick={(e) =>
                      setCalendarProps((prev) => ({
                        ...prev,
                        anchor: e.currentTarget,
                        calendarType: "Month",
                      }))
                    }
                  >
                    Month
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "16px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color:
                        calendarProps.calendarType === "Range"
                          ? "#F1B53D"
                          : "#949494",
                      textTransform: "capitalize",
                    }}
                    px={1}
                    component={Button}
                    onClick={(e) =>
                      setCalendarProps((prev) => ({
                        ...prev,
                        anchor: e.currentTarget,
                        calendarType: "Range",
                      }))
                    }
                  >
                    Range
                  </Typography>
                </Grid>
                <Grid
                  height={"50%"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  gap={2}
                >
                  <ArrowBackIosIcon sx={{ color: "#F1B53D" }} />

                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "12px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color: "#949494",
                    }}
                  >
                    {getDisplayDate()}
                  </Typography>

                  <ArrowForwardIosIcon sx={{ color: "#F1B53D" }} />
                </Grid>
              </Grid>
            </Grid>
            {utilizedReports === null ? (
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Loader />
              </Grid>
            ) : (
              <Grid height={"55%"} display={"flex"} gap={2}>
                <Grid
                  width={"33.33%"}
                  borderRight={theme.border?.newGreyBorder}
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "40px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color: "#717171",
                    }}
                  >
                    {utilizedReports?.quantity}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "16px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color: "#AEAEAE",
                    }}
                  >
                    Quantity
                  </Typography>
                </Grid>
                <Grid
                  width={"33.33%"}
                  borderRight={theme.border?.newGreyBorder}
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "40px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color: "#717171",
                    }}
                  >
                    {`S$ ${
                      utilizedReports?.amount
                        ? (utilizedReports?.amount).toFixed(2)
                        : "0"
                    }`}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "16px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color: "#AEAEAE",
                    }}
                  >
                    Total Amount
                  </Typography>
                </Grid>
                <Grid
                  width={"33.33%"}
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "40px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color: "#717171",
                    }}
                  >
                    {`S$ ${
                      utilizedReports?.reimbursementCost
                        ? (utilizedReports?.reimbursementCost).toFixed(2)
                        : "0"
                    }`}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "16px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color: "#AEAEAE",
                    }}
                  >
                    Reimbursement Cost
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
      <Grid height={"40%"}>
        {dashboardPermissions("read") && (
          <Grid
            width={"100%"}
            height={"100%"}
            borderRadius={"16px"}
            sx={{ background: theme.color?.background }}
            border={theme.border?.newGreyBorder}
            display={"flex"}
            flexDirection={"column"}
            overflow={"hidden"}
          >
            <Grid
              height={"30%"}
              borderBottom={theme.border?.newGreyBorder}
              display={"flex"}
            >
              <Grid width={"80%"} display={"flex"} alignItems={"center"}>
                <Grid
                  width={"60%"}
                  display={"flex"}
                  alignItems={"center"}
                  gap={2}
                  pl={"8vh"}
                >
                  <Grid
                    borderRadius={"50%"}
                    p={1}
                    sx={{ backgroundColor: "#D1F5FD" }}
                    display={"flex"}
                    alignItems={"center"}
                  >
                    <ReceiptIcon sx={{ color: "#7CCEE0" }} />
                  </Grid>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: "20px",
                      fontWeight: theme.font?.fontWeight.thick,
                      color: "#949494",
                    }}
                  >
                    Reimbursement Status
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                width={"20%"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: "12px",
                    fontWeight: theme.font?.fontWeight.slightThick,
                    color: "#949494",
                  }}
                >
                  Last report generated on:{" "}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: "14px",
                    fontWeight: theme.font?.fontWeight.thick,
                    color: "#717171",
                  }}
                >
                  {lastGenerated}
                </Typography>
              </Grid>
            </Grid>
            <Grid height={"75%"} display={"flex"}>
              <VoucherDetails
                header={" Physical Voucher Reimbursement"}
                to={"physicalVoucher"}
                reportCount={physicalVoucherCounts}
                borderRight={theme.border?.newGreyBorder}
                canRedirect={physicalVoucherPermissions("read") ? true : false}
                loading={loading}
              />

              <VoucherDetails
                header={"e-Voucher Reimbursement"}
                to={"eVoucher"}
                reportCount={physicalEVoucherCounts}
                canRedirect={eVoucherPermissions("read") ? true : false}
                loading={loading}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      {dashboardPermissions("read") && (
        <Grid height={"20%"} display={"flex"} gap={3}>
          {activeFlashSalesPermissions("read") && (
            <PromotionDetails
              Label={"Active Flash Sales"}
              LabelValue={countsData?.Flashsale}
              to={"flashsale?tab=activeFlashSales"}
              Icon={ShoppingCartCheckoutIcon}
              isLoading={countsData === null}
              canRedirect={activeFlashSalesPermissions("read") ? true : false}
            />
          )}
          {activeRewardsPermissions("read") && (
            <PromotionDetails
              Label={"Active Rewards"}
              LabelValue={countsData?.RewardCatalogue}
              to={"deals?tab=activeRewards"}
              Icon={HandshakeIcon}
              isLoading={countsData === null}
              canRedirect={activeRewardsPermissions("read") ? true : false}
            />
          )}
          {activePromotionsPermissions("read") && (
            <PromotionDetails
              Label={"Active Promotions"}
              LabelValue={countsData?.Highlight}
              to={"promotions?tab=activePromotions"}
              Icon={CampaignIcon}
              isLoading={countsData === null}
              canRedirect={activePromotionsPermissions("read") ? true : false}
            />
          )}
        </Grid>
      )}
      <DatePickerCalender
        props={calendarProps}
        setProps={setCalendarProps}
        getDates={getDates}
      />
    </Grid>
  );
};

export default DashboardNewUI;
